import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { ToastService } from '../toast.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.scss'],
})
export class CreateProductComponent {

  vendorObj:any;
  vendorId;
  vendorName;
  wareHouseObj:any;
  warehouseName;
  warehouseId;
  ZoneObj;
  zoneId;
  zoneName;
  postvendor:any;
  loader:boolean=false;
  activeInd:boolean=true;
  name;
  sku;
  upc;
  stockOutQty;
  price;
  editBool:boolean=false;
  id;
  item:any;
  barcode;
  qty;
  serviceTypeObj=[{id:1,name:"Org Service"},
                  {id:3,name:"Ads Service"}];
  serviceTypeId:any=1;
  serviceTypeName:any="Org Service";
  pic:any;
  data:any;
  scanBool:boolean=false;
  printItem:any=[{id:1}];
  openPop:boolean=false;
  barcodeValue;
  description;
  fontStyle;

  plu;
  code;
  category;
  cateId;
  cateName;
  constructor(public service: ApiService,
    public handler: HandlerService,
    public toast: ToastService,
    public router: Router,
    private bottomSheet: MatBottomSheet,
    public platform:Platform,
   public auth:AuthService) { }

  ionViewWillEnter() {
    this.fontStyle=localStorage.getItem('lang');
    let url = window.location.href;
    this.id = window.location.href.split('/').pop();
    this.getCategory();
 
    if (url.includes('edit-product')) {
      this.loader =true;
      this.editBool=true;
      this.id= window.location.href.split('/').pop();
      this.service.getProductById(this.id).subscribe((res:any)=>{
          this.item=res;
          this.name = res.name;
          this.plu = res.plu;
          this.description=res.description;
          this.activeInd=res.activeInd;       
          this.code = res.code;
          this.loader=false;
          this.pic=res.img; 
          this.cateId = res.purchaseCategory;    
          setTimeout(() => {
            this.category.map(res1 => {
              if (res1.id == this.cateId) {
                this.cateName = res1.name;
                this.cateId = res1.id;
              }
            })
          }, 1000);

      },
      err=>{
        this.handler.err(err);
        this.loader=false;
      })
      
    }
    else{
      this.editBool = false;
    }
   
  }
  create() {
    if(this.cateId){
    this.loader = true;
    var post={
      "name": this.name,
      "code": this.code,
      "description": this.description,
      "plu": this.plu,
      "img": this.pic,
      "purchaseCategory":this.cateId,
      "activeInd": true,
      "orgId" :790
  
      }
    this.service.createProduct(post).subscribe(res=>{
      this.handler.res("Product Created Successfully");
      this.loader = false;
      this.router.navigate(['/manage-products']);

    },
    err=>{
      this.loader=false;
      this.handler.err(err);

    })
  }else{
    this.handler.err('Please Enter Required Fields')
  }
  }
  editService() {
    if(this.cateId){
    this.loader = true;
    if (this.name) {
      this.name = this.name.toUpperCase();
    }
    if (!this.pic) {
      var img = new Image();
      img.src="assets/setting.png"
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);    
      this.pic = canvas.toDataURL('image/jpeg', 1.5);  
    }
    this.loader = true;
    this.item.name=this.name;
    this.item.code=this.code;
    this.item.img = this.pic;
    this.item.description=this.description;
    this.item.activeInd=this.activeInd;
    this.item.purchaseCategory = this.cateId;
    this.item.plu=this.plu;
    this.item.orgId=790;   
    this.service.updateProduct(this.id,this.item).subscribe(res=>{
      this.handler.res("Product Updated Successfully");
      this.loader = false;
      this.router.navigate(['/manage-products'])

    },
    err=>{
      this.loader=false;
      this.handler.err(err);

    })
  }else{
    this.handler.err('Please Enter Required Fields')
  }
  }

  handleFile(files) {
    if (files[0].size < 1048576) {
      var img = new Image();
      img.src = URL.createObjectURL(files[0]);
      img.onload = (data) => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        this.pic = canvas.toDataURL('image/jpeg', 1.5);
      }
    }
    else {
      this.handler.res('Image Size Should Not Exceeds 1mb ');
    }

  }   

  openBottomSheetZone(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.ZoneObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.zoneName = res.name;
        this.zoneId = res.id;
      }
    });
  }
  openBottomSheetVendor(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.vendorObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.vendorName = res.name;
        this.vendorId = res.id;
        this.postvendor = res;
      }
    });
  }
  openBottomSheetPurchase(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;  
        }
    });
  }

  getCategory(){
    this.service.getAllPurchaseCategory().subscribe((res:any)=>{
      this.category=res;
      this.category.map(dat=>{
        if(dat.id==this.cateId){
          this.cateName = dat.name;
        }
      })
      this.loader=false;
    })
  }

  ionViewWillLeave(){
    this.scanBool=false;
  }
     
  onValueChanges(result){
    this.barcodeValue = result.codeResult.code;
  }

onStarted(started){
(started);
}

removeItem(){
  this.loader=true;
   this.service.deleteProductById(this.id).subscribe(res=>{
     this.handler.res('Item Deleted Successfully')
     this.loader=false;
    this.router.navigate(['/get-product'])
   },
   err=>{
     this.loader=false;
     this.handler.err(err);
   })
 }

 

}


